import { mapState as rootMapState } from 'pinia';
import { mapState, mapActions } from '@/store/helpers';
import { useUserStore, usePageStore } from '@/store';
import signLog from '../../components/sign-log';
import { numberFormat } from '../../common/format';
export default {
    emits: ['onPopRegister'],
    i18next: { ns: 'md-detail-info' },
    inject: ['styleTheme'],
    data: function() {
        return {
            price: '',
            message: this.$t('md-detail-info.imInterestedInThis'),
            msgEmpty: false,
            priceEmpty: false
        };
    },
    props: {
        additionalTitle: String
    },
    computed: {
        ...rootMapState(usePageStore, {
            currencySymbol: store => store.currency.symbol,
            usdCurrencyRate: store => store.usdCurrencyRate
        }),
        ...rootMapState(useUserStore, {
            user: store => store.user
        }),
        ...mapState({
            listingDetailId: store => (store.listingDetail.info || {}).id,
            makeOfferButtonText: store => store.makeOfferButtonText,
            makeOfferTitle: store => store.makeOfferTitle
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        additionalTitleLabel({ additionalTitle }) {
            return additionalTitle || this.$t('md-detail-info.additional');
        }
    },
    methods: {
        ...mapActions({
            updateScheduleTour: 'updateScheduleTour'
        }),
        onPriceInput() {
            this.price = this.price.replace(this.currencySymbol, '');
            this.price = this.price.replace(/[,]/g, '');
            if (this.price) {
                this.price =
                    `${this.currencySymbol}` + numberFormat(this.price, false);
            } else {
                this.price = '';
            }
        },
        onPriceKeydown($event) {
            if (/[0-9]/.test($event.key) || $event.key == 'Backspace') {
                return true;
            } else {
                $event.preventDefault();
            }
        },
        check() {
            return (
                !(this.priceEmpty = !(this.price = this.price.trim())) &&
                !(this.msgEmpty = !(this.message = this.message.trim()))
            );
        },
        registerFirst() {
            this.$emit('onPopRegister');
            // exist schedulePop middle
            // When the login registration callback function is executed ， current schedule-offer and schedule have been destroyed
            signLog.register({
                onsuccess: () => {
                    this.requestOffer();
                }
            });
        },
        prepareOffer() {
            if (!this.check()) {
                return;
            }
            if (!this.user) {
                return this.registerFirst();
            }
            return this.requestOffer();
        },
        async requestOffer() {
            let price = this.price.replace(this.currencySymbol, '');
            price = price.replace(/[,]/g, '');
            if (this.currencySymbol !== '$') {
                price = parseInt(price / this.usdCurrencyRate);
            }

            const message = this.message;
            await this.axiosIns.post('/api-site/listing/add/listing-offer', {
                listingId: this.listingDetailId,
                isSold: false,
                price,
                message
            });
            this.$emit('onSuccess', {
                offer: {
                    message,
                    price
                }
            });
        }
    }
};
